import { SearchItemOperator } from '@Types/api/common/filters';
import { Mapper } from '@Features/utils/prepareSearchCriterias';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  empNumber: '',
  company: null,
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  empNumber: 'eq',
  company: 'eq',
};

export const getFiltersMapper = (): Mapper => (key, value) => {
  if (key === 'empNumber') {
    return ['employeeNumber', value];
  }

  if (key === 'company') {
    return ['companyId', value];
  }

  return ['', value];
};
